<template>
  <v-select
    :id="'#'+header.id"
    :key="'#'+header.id"
    :items="items"
    :hint="editing ? header.editHint : header.createHint"
    v-model="itemId"
    :label="header.text"
    :required="required"
    :rules="required ? [rules.required] : []"
    :disabled="disabled"
    item-text="name"
    item-value="id"
    single-line
    autocomplete
    cache-items
    persistent-hint
    :search-input.sync="query"
    :loading="searching">
  </v-select>
</template>

<script>
  import Base from './Base.vue'

  export default {
    name: 'CrudRemoteSelect',
    extends: Base,
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      editing: {
        type: Boolean,
        default: true
      },
      required: {
        type: Boolean,
        default: true
      },
      header: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        itemId: null,
        query: null,
        searching: false,
        items: []
      }
    },
    watch: {
      query (val) {
        if (val) {
          // this.search(val)
        }
      },
      itemId (val) {
        this.$app.log(val)
        this.$emit('input', val)
      }
    },
    methods: {
      search (val) {
        this.searching = true
        this.axios.get(this.header.options, {
          params: {
            search: val
          }
        }).then(response => {
          this.$app.log('Select option items ' + response.data.data[0]['id'])
          this.searching = false
          this.items = []
          this.items = this.items.concat(response.data.data)
        })
          .catch(error => {
            this.searching = false
            this.$app.log(error)
          })
      }
    },
    created () {
      this.search('test')
    },
    mounted () {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CrudRemoteSelect.vue